export default {
  master_title: 'Modo marca - Menú',
  title: 'Menú',
  form: {
    has_internal_product_numbers: {
      label: 'Asignar números de producto',
      tooltip:
        'Asigna automáticamente números a los productos según su posición en el menú. El número se imprime en los recibos',
    },
  },
  buttons: {
    new_menu: 'Nuevo menú',
    export_menu: 'Exportar menú',
    refresh: 'Actualizar',
  },
  modals: {
    delete_category: {
      title: 'Eliminar {{name}}',
    },
    delete_products: {
      title: '¿Eliminar {{count}} productos?',
      description: '<strong>{{count}}</strong> se eliminarán del menú',
    },
  },
  toasts: {
    failed_to_load_data: 'Error al cargar los datos',
    failed_to_delete_menu: 'No se pudo eliminar el menú, inténtalo de nuevo',
    menu_got_deleted: 'El menú fue eliminado',
    failed_to_delete_category: 'No se pudo eliminar la categoría, inténtalo de nuevo',
    category_got_deleted: 'La categoría fue eliminada',
    failed_to_delete_products: 'No se pudieron eliminar los productos, inténtalo de nuevo',
    product_got_deleted_one: 'El producto fue eliminado',
    product_got_deleted_other: 'Los productos fueron eliminados',
    failed_to_generate_product_number: 'Algo salió mal. Por favor, recarga la página e inténtalo de nuevo',
    menu_exported: 'El menú ha sido exportado',
    failed_to_export_menu: 'Error al exportar el menú',
  },
};
